/* eslint-disable prefer-destructuring,func-names,react/prop-types  */
import React, { Component } from 'react';
import MetaView from './MetaView';

const RELEASE_VERSION = process.env.RELEASE_VERSION || '--- no version tag ---';
const RELEASE_DATE = process.env.RELEASE_DATE || '--- no release date ---';
const ENV = process.env.NODE_ENV;

export default class MetaContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { version: RELEASE_VERSION, date: RELEASE_DATE };
  }

  render() {
    return (
      <MetaView {...this.state} env={ENV} />
    );
  }
}
